/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointments/view.blocks to change it.
import React from 'react'
import TabContent from './TabContent/index'
import Tabs from './Tabs/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Appointments({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Appointments.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Appointments.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Tabs
  viewPath={`${viewPath}/Tabs`}
/>
</div>
<div
  data-testid="Appointments.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<TabContent
  viewPath={`${viewPath}/TabContent`}
/>
</div>
</div>
{children}
</React.Fragment>)
}